// extracted by mini-css-extract-plugin
module.exports = {"container":"AntiSlavery_container__21-a4","section":"AntiSlavery_section__2GQZJ","opn-nav":"AntiSlavery_opn-nav__2gWXb"};